
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import NetworkSection from './components/NetworkSection';
import WhyChooseUs from './components/WhyChooseUs';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_SC']">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <NetworkSection />
      <WhyChooseUs />
      <ContactSection />
      <Footer />
    </div>
  );
}
